import { render, staticRenderFns } from "./LogoDark.vue?vue&type=template&id=0bd17982&scoped=true&"
import script from "./LogoDark.vue?vue&type=script&lang=js&"
export * from "./LogoDark.vue?vue&type=script&lang=js&"
import style0 from "./LogoDark.vue?vue&type=style&index=0&id=0bd17982&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd17982",
  null
  
)

export default component.exports